import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2235_employee_holiday_calendar_view: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "My Holiday Calendar",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "Timing",
            style: { marginBottom: 16 },
            childComponents: [
              {
                componentType: ComponentType.CUSTOM,
                customType: "weeklyOffCalendar",
                apiname: "/pabws/hrms/attendance/holidays",
              } as any,
            ],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            DisplayName: "Upcoming Holidays",
            Name: "my_holiday_calendar_view",
            // User-scoped endpoint: returns upcoming holidays for the logged-in employee
            apiname: "/pabws/hrms/attendance/holidays",
            titleValue: "holiday_name",
            Form: {
              Name: "my_holiday_calendar_view",
              TableName: "holiday_list",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "Holiday Date",
                  BindValue: "holiday_date",
                  Json_Attribute: "holiday_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Holiday Name",
                  BindValue: "holiday_name",
                  Json_Attribute: "holiday_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Type",
                  BindValue: "holiday_type",
                  Json_Attribute: "holiday_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Applicable To",
                  BindValue: "applicable_to",
                  Json_Attribute: "applicable_to",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Paid",
                  BindValue: "paid_holiday",
                  Json_Attribute: "paid_holiday",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  valueFormat: "boolean",
                } as any,
              ],
            },
          } as any,
        ],
      },
    ],
  },
];

